module.exports = __webpack_public_path__ + "3553a48c3d28f3ea28322176fb9076f8.svg";